import { render, staticRenderFns } from "./News.vue?vue&type=template&id=1aa8c6e6&"
import script from "./News.vue?vue&type=script&lang=ts&"
export * from "./News.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa8c6e6')) {
      api.createRecord('1aa8c6e6', component.options)
    } else {
      api.reload('1aa8c6e6', component.options)
    }
    module.hot.accept("./News.vue?vue&type=template&id=1aa8c6e6&", function () {
      api.rerender('1aa8c6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News.vue"
export default component.exports